import { IconSystemV2CourseTimer } from '@doltech/icons/SystemV2/IconSystemV2CourseTimer';
import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import cl from 'classnames';
import * as React from 'react';
import Timer from 'react-compound-timer';
import styled from 'styled-components';

const Main = styled.div`
  border-radius: 8px;
  display: flex;
  padding: 2px 6px 2px 2px;
  height: max-content;
  align-self: center;
  align-items: center;

  .time-wrapper {
    width: max-content;
    padding: 0 8px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
`;

interface TimeLimitSharedLayoutProps {
  uuid: string;
  duration: number;
  startedTimeInMilliseconds?: number;
  children?: React.ReactNode;
  onTimeUp: () => void;
  startImmediately?: boolean;
  onProgress?: (time) => void;
  progressPathColor?: string;
  className?: string;
}

export const TimeLimitSharedLayout = (props: TimeLimitSharedLayoutProps) => {
  const {
    uuid,
    duration,
    startedTimeInMilliseconds = duration,
    onTimeUp,
    onProgress,
    children,
    className,
    ...rest
  } = props;
  const { isDesktop } = useDeviceDetect();

  return (
    <Main className={cl('time-limit', { 'not-mobile': isDesktop }, className)}>
      <IconSystemV2CourseTimer fontSize={20} color="gray120" />
      <div className="time-wrapper">
        <Timer
          key={uuid}
          initialTime={startedTimeInMilliseconds}
          lastUnit="m"
          direction="backward"
          timeToUpdate={1000}
          checkpoints={[
            {
              time: 0,
              callback: onTimeUp,
            },
          ]}
          {...rest}
        >
          {({ getTime }) => {
            onProgress(getTime() / 1000);
          }}
        </Timer>
        {children}
      </div>
    </Main>
  );
};
